import VuexORM from '@vuex-orm/core';
import Vue from 'vue';
import Vuex from 'vuex';

import AuthModel from '@core/auth/model';

// eslint-disable-next-line import/order
import {
    Branding,
    Collection,
    Activity,
    Account,
    Organisation,
    Adviser,
    Broker,
    BusinessStage,
    Company,
    CompanyNews,
    Custodian,
    ExchangeListing,
    FeePlan,
    Fund,
    FundNews,
    FundManager,
    FundStructure,
    Holding,
    Integration,
    AdviserExportIntegration,
    IhtSector,
    Introducer,
    InvestmentFocus,
    InvestmentStrategy,
    Investor,
    InvestorRegistration,
    InvestorAdviserRelationship,
    Nominee,
    Offer,
    Product,
    Proposal,
    Provider,
    ProviderInvestor,
    Registrar,
    ReceivingAgent,
    Sector,
    Shortlist,
    Transaction,
    User,
    RemoteApplication,
    RestrictedPanel,
    RatePlan,
    RatePlanEntry,
    BillingGroup,
    Subscription,
    Media,
    MediaFile,
    MediaAdviser,
    MediaMarketing,
    MediaInvestor,
    CorporateAction,
    Tranche,
    ProductOffer,
    VisibilityGroup,
    Registration,
    Agreement,
    Terms,
    Notification,
    Valuation,
    Exchange
} from '@/models';

// Vuex Modules
import app from '@core/store/modules/app';
import countries from '@core/store/modules/countries';
import dialogQueue from '@core/store/modules/dialogQueue';
import features from '@core/store/modules/features';
import filterPanels from '@core/store/modules/filterPanels';
import i18n from '@core/store/modules/i18n';
import keyboard from '@core/store/modules/keyboard';
import preferences from '@core/store/modules/preferences';
import requests from '@core/store/modules/requests';
import routerHistory from '@core/store/modules/routerHistory';
import settings from '@core/store/modules/settings';
import snackQueue from '@core/store/modules/snackQueue';
import system from '@core/store/modules/system';

const database = new VuexORM.Database();
database.register(AuthModel);
database.register(Branding);
database.register(Collection);
database.register(Activity);
database.register(Adviser);
database.register(Broker);
database.register(BusinessStage);
database.register(Company);
database.register(CompanyNews);
database.register(Custodian);
database.register(ExchangeListing);
database.register(FeePlan);
database.register(Fund);
database.register(FundNews);
database.register(FundManager);
database.register(FundStructure);
database.register(Holding);
database.register(Integration);
database.register(AdviserExportIntegration);
database.register(IhtSector);
database.register(Introducer);
database.register(InvestmentFocus);
database.register(InvestmentStrategy);
database.register(Investor);
database.register(InvestorRegistration);
database.register(InvestorAdviserRelationship);
database.register(Nominee);
database.register(Offer);
database.register(Organisation);
database.register(Product);
database.register(Proposal);
database.register(Provider);
database.register(ProviderInvestor);
database.register(Registrar);
database.register(ReceivingAgent);
database.register(Sector);
database.register(Shortlist);
database.register(User);
database.register(RemoteApplication);
database.register(RestrictedPanel);
database.register(RatePlan);
database.register(RatePlanEntry);
database.register(BillingGroup);
database.register(Subscription);
database.register(Media);
database.register(MediaFile);
database.register(MediaAdviser);
database.register(MediaMarketing);
database.register(MediaInvestor);
database.register(Account);
database.register(Transaction);
database.register(CorporateAction);
database.register(Tranche);
database.register(ProductOffer);
database.register(VisibilityGroup);
database.register(Registration);
database.register(Agreement);
database.register(Terms);
database.register(Notification);
database.register(Valuation);
database.register(Exchange);

Vue.use(Vuex);

export const storeConfig = {
    plugins: [VuexORM.install(database)],
    modules: {
        ...app,
        ...features,
        ...preferences,
        ...countries,
        ...dialogQueue,
        ...filterPanels,
        ...i18n,
        ...requests,
        ...routerHistory,
        ...snackQueue,
        ...system,
        ...keyboard,
        ...settings
    }
};

export default new Vuex.Store(storeConfig);
